import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { actions as JobActions, selectors as JobSelectors } from "store/modules/jobs";
import TableComponent from "../TableComponent";

const TotalPage = (props) => {
  const dispatch = useDispatch();
  const pageInfo = useSelector(JobSelectors.getUpcomingTotalPaginationData)
  const jobListData = useSelector(JobSelectors.getListData({ timeframe: 'upcoming', status: 'total', part: "data" }))
  const pageFilter = useSelector(JobSelectors.getListData({ timeframe: 'upcoming', status: 'total', part: "filter" }))
  const pageSort = useSelector(JobSelectors.getListData({ timeframe: 'upcoming', status: 'total', part: "sort" }))
  const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
    dispatch(JobActions.setUpcomingTotalPageSize(pageSize));
    dispatch(JobActions.setUpcomingTotalFilter(filters));
    dispatch(JobActions.setUpcomingTotalSort(sortBy));
    dispatch(JobActions.fetchUpcomingTotalJobs(pageIndex));
  }, []);

  return <TableComponent pageInfo={pageInfo} jobListData={jobListData} pageFilter={pageFilter} pageSort={pageSort} fetchData={fetchData} history={props.history} />
}

export default TotalPage